import { api } from '@/lib/api'

// ── Emballage ────────────────────────────────────────────────────
export interface Emballage {
  id: number; organisation_id: number; type_emballage: string
  artikelnummer?: string | null; aantal: number; waarde_per_stuk: number; totale_waarde: number
  opslaglocatie?: string | null; inkoopfactuurnr?: string | null
  crediteurnummer?: string | null; opmerkingen?: string | null
}
export type EmballagePayload = Omit<Emballage, 'id' | 'organisation_id' | 'totale_waarde'> & { totale_waarde?: number | null }

export const fetchEmballage   = (orgId: number, zoek?: string) =>
  api.get<Emballage[]>(`/api/materiaal/emballage/${orgId}`, { params: { zoek } }).then(r => r.data)
export const aanmakenEmballage = (orgId: number, data: EmballagePayload) =>
  api.post<Emballage>(`/api/materiaal/emballage/${orgId}`, data).then(r => r.data)
export const bijwerkenEmballage = (orgId: number, id: number, data: Partial<EmballagePayload>) =>
  api.put<Emballage>(`/api/materiaal/emballage/${orgId}/${id}`, data).then(r => r.data)
export const verwijderenEmballage = (orgId: number, id: number) =>
  api.delete(`/api/materiaal/emballage/${orgId}/${id}`)

// ── Verpakking ───────────────────────────────────────────────────
export interface Verpakking {
  id: number; organisation_id: number; artikel: string
  artikelnummer?: string | null; aantal: number; eenheid?: string | null
  inkoopprijs_per_eenheid: number; totale_waarde: number
  minimum_voorraad?: number | null; status?: string | null
  crediteur?: string | null; opslaglocatie?: string | null
  inkoopfactuurnr?: string | null; crediteurnummer?: string | null
  opmerkingen?: string | null
}
export type VerpakkingPayload = Omit<Verpakking, 'id' | 'organisation_id' | 'totale_waarde'> & { totale_waarde?: number | null }

export const fetchVerpakking   = (orgId: number, zoek?: string) =>
  api.get<Verpakking[]>(`/api/materiaal/verpakking/${orgId}`, { params: { zoek } }).then(r => r.data)
export const aanmakenVerpakking = (orgId: number, data: VerpakkingPayload) =>
  api.post<Verpakking>(`/api/materiaal/verpakking/${orgId}`, data).then(r => r.data)
export const bijwerkenVerpakking = (orgId: number, id: number, data: Partial<VerpakkingPayload>) =>
  api.put<Verpakking>(`/api/materiaal/verpakking/${orgId}/${id}`, data).then(r => r.data)
export const verwijderenVerpakking = (orgId: number, id: number) =>
  api.delete(`/api/materiaal/verpakking/${orgId}/${id}`)

// ── Overig ───────────────────────────────────────────────────────
export interface OverigActief {
  id: number; organisation_id: number; omschrijving: string
  categorie?: string | null; aantal: number; eenheid?: string | null
  waarderingsprijs_per_eenheid: number; totale_waarde: number
  inkoopfactuurnr?: string | null; crediteurnummer?: string | null
  inslagdatum?: string | null; opmerkingen?: string | null
}
export type OverigPayload = Omit<OverigActief, 'id' | 'organisation_id' | 'totale_waarde'> & { totale_waarde?: number | null }

export const fetchOverig   = (orgId: number, zoek?: string) =>
  api.get<OverigActief[]>(`/api/materiaal/overig/${orgId}`, { params: { zoek } }).then(r => r.data)
export const aanmakenOverig = (orgId: number, data: OverigPayload) =>
  api.post<OverigActief>(`/api/materiaal/overig/${orgId}`, data).then(r => r.data)
export const bijwerkenOverig = (orgId: number, id: number, data: Partial<OverigPayload>) =>
  api.put<OverigActief>(`/api/materiaal/overig/${orgId}/${id}`, data).then(r => r.data)
export const verwijderenOverig = (orgId: number, id: number) =>
  api.delete(`/api/materiaal/overig/${orgId}/${id}`)
